'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const ToolsIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.6601 15.9342C18.3032 15.9342 21.2543 12.9831 21.2543 9.33996C21.2543 8.58056 21.1293 7.85001 20.889 7.16751L18.2071 9.84942C17.0824 10.9741 15.2656 10.9741 14.1506 9.84942C13.0259 8.72475 13.0259 6.90797 14.1506 5.79291L16.8325 3.11101C16.15 2.87069 15.4194 2.74573 14.6601 2.74573C11.0169 2.74573 8.06583 5.69679 8.06583 9.33996C8.06583 10.2435 8.24847 11.0991 8.57529 11.8777L3 17.453L6.54704 21L12.1223 15.4247C12.901 15.7515 13.7565 15.9342 14.6601 15.9342Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpToolsIcon = forwardRef(ToolsIcon);

export { VpToolsIcon as default };
